<template>
  <div class="app-shell">
    <div class="app-content">
      <router-view></router-view>
    </div>
    <footer class="app-footer">
      <div class="app-footer-inner">
        <div class="app-footer-company">© 2026 上海全游荟科技有限公司</div>
        <div class="app-footer-records">
          <span class="app-footer-record">
            <img class="app-footer-police-icon" src="@/assets/commonPc/police-badge.svg" alt="">
            <span>沪公网安备 xxxxxxxx</span>
          </span>
          <span class="app-footer-record">沪ICP备2026018541号-1</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import {initTIM} from "@/util/im";
import {useUserStore} from '@/stores/user';

export default {
  name: 'App',
  data() {
    return {
      store: null,
    };
  },
  created() {
    this.store = useUserStore()
    this.store.imReady = false
    initTIM(this);
  },
  watch: {
    // 监听 imId 变化：用户重新登录后（imId 从空变为有值）重新初始化 IM
    'store.imId'(val) {
      if (val) {
        initTIM(this);
      }
    }
  },
  components: {}
}
</script>

<style lang="scss">
@font-face {
  font-display: swap;
  font-family: Regular;
  font-style: normal;
  font-weight: 400;
  src: url("@/assets/font/HarmonyOS_Sans_SC_Light.woff2")
}

@font-face {
  font-display: swap;
  font-family: Routine-Regular;
  font-style: normal;
  font-weight: 400;
  src: url("@/assets/font/HarmonyOS_Sans_SC_Regular.woff2");
}

@font-face {
  font-display: swap;
  font-family: Medium;
  font-style: normal;
  font-weight: 400;
  src: url("@/assets/font/HarmonyOS_Sans_SC_Medium.woff2");
}

//@font-face {
//  font-display: swap;
//  font-family: Bold;
//  font-style: normal;
//  font-weight: 400;
//  src: url("@/assets/font/HarmonyOS_Sans_SC_Bold.woff2");
//}

@font-face {
  font-display: swap;
  font-family: alimamashuheiti;
  font-style: normal;
  font-weight: 400;
  src: url("@/assets/font/AlimamaShuHeiTi-Bold.woff2");
}

//@font-face {
//  font-display: swap;
//  font-family: Rubik-Regular;
//  font-style: normal;
//  font-weight: 400;
//  src: url("@/assets/font/Rubik-Regular.woff2");
//}

@font-face {
  font-display: swap;
  font-family: Rubik-Medium;
  font-style: normal;
  font-weight: 400;
  src: url("@/assets/font/Rubik-Medium.woff2");
}

//@font-face {
//  font-display: swap;
//  font-family: Rubik-BoldItalic;
//  font-style: normal;
//  font-weight: 400;
//  src: url(https://public-image.pxb7.com/front/Rubik-BoldItalic.ttf)
//}

@font-face {
  font-display: swap;
  font-family: Rubik-Semi-Bold;
  font-style: normal;
  font-weight: 400;
  src: url("@/assets/font/Rubik-Medium.woff2");
}

@font-face {
  font-display: swap;
  font-family: Regular;
  font-style: normal;
  font-weight: 400;
  src: url("@/assets/font/HarmonyOS_Sans_SC_Light.woff2")
}

//@font-face {
//  font-display: swap;
//  font-family: Rubik-Regular;
//  font-style: normal;
//  font-weight: 400;
//  src: url("@/assets/font/Rubik-Regular.woff2");
//}
#app {
  height: 100%;
  min-height: 100%;
  font-size: 16px;
  color: var(--text-color);
  background: #f4f5f7;
  font-family: Regular;
}

.app-shell {
  min-height: 100%;
  background: #f4f5f7;
  display: flex;
  flex-direction: column;
}

.app-content {
  flex: 1 0 auto;
}

.app-footer {
  flex-shrink: 0;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border-top: 1px solid #eef2f8;
  color: #55627a;
  font-size: 13px;
  line-height: 24px;
}

.app-footer-inner {
  min-height: 64px;
  padding: 0 max(80px, calc((100vw - 1400px) / 2));
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

.app-footer-records {
  display: flex;
  align-items: center;
  gap: 22px;
  white-space: nowrap;
}

.app-footer-record,
.app-footer-company {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.app-footer-company {
  color: #74829a;
}

.app-footer-police-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  object-fit: contain;
}
</style>
